/**
 * @generated SignedSource<<871c525e86d701c6ea4327f6156e2294>>
 * @relayHash efbccdac5bb753d6ce419c019fa1aaca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439

import type { ConcreteRequest, Query } from 'relay-runtime';
export type LicenseStatus = "ACTIVE" | "SUSPENDED" | "UNLICENSED" | "%future added value";
export type useLicensedProductsQueryForGlobalAppShortcutsQuery$variables = Record<PropertyKey, never>;
export type useLicensedProductsQueryForGlobalAppShortcutsQuery$data = {
  readonly confluence_tenantContext: {
    readonly licensedProducts: ReadonlyArray<{
      readonly licenseStatus: LicenseStatus;
      readonly productKey: string;
    }>;
  } | null | undefined;
};
export type useLicensedProductsQueryForGlobalAppShortcutsQuery = {
  response: useLicensedProductsQueryForGlobalAppShortcutsQuery$data;
  variables: useLicensedProductsQueryForGlobalAppShortcutsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "LicensedProduct",
        "kind": "LinkedField",
        "name": "licensedProducts",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "licenseStatus"
          },
          {
            "kind": "ScalarField",
            "name": "productKey"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "efbccdac5bb753d6ce419c019fa1aaca",
    "id": "2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439",
    "metadata": {},
    "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
    "operationKind": "query",
    "text": "query useLicensedProductsQueryForGlobalAppShortcutsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
  }
};
})();

(node as any).hash = "4173fb2f98b7988a84dc02df0399a348";

export default node;
